import React from 'react'
import { PALETTE } from '../../common/ThemeConstants'
import { Container } from 'react-bootstrap'

export default function ContainerCover({ children, backgroundImage, className, color = PALETTE.DARKGRAY }) {
  return (
    <Container
      className={className}
      style={{
        color: color,
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        // backgroundAttachment:"fixed",
        backgroundPosition: "center",
        minHeight: "100vh",
        maxWidth: "100%",
        paddingBottom: "2px"
      }}
    >
      {children}
    </Container>
  )
}